module.exports = __webpack_public_path__ + "img/paid-stamp.2296004d.png";